export var carriRoutes = {
    "/carri": {
        "loginRequired": true,
        "name": "carri",
        "type": "frontend",
        "component": "carriMain",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/carri/carri.module.js");
                }
            },
        ],
        route_styles: {
            framework: "bootstrap_v4"
        },
        onEnter: ['$state', '$q', 'brandServices', '$modal', 'hUser', 'carriService', function($state, $q, brandServices, $modal, hUser, carriService){
            var defer = $q.defer();
            var brandId = hUser.data.user.brands_list[0].id;
            var brandHasService = brandServices.check(brandServices.SERVICES.CARRI_RAPID_RESPONSE, brandId);
            brandHasService.then(function(isCarriEnabled){
                if(!isCarriEnabled){
                    hRedirect('/dashboard');
                }
                else {
                    carriService.hasCampaigns(brandId).then(function(hasCampaign){
                        if (!hasCampaign) {
                            $state.go('carri.wizard');
                        }

                        defer.resolve();
                        // wait until state transition completed
                        setTimeout(function () {
                            // incase user entered to carri like /carri
                            if ( $state.current.name === 'carri') {
                                $state.go('carri.dashboard');
                            }
                        }, 100);
                    });
                }
            });

            return defer.promise;
        }]
    },
    "/wizard": {
        "loginRequired": true,
        "name": "carri.wizard",
        "views": {
            "body": {
                "component": "carriWizardContainer",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Carri Employees Dashboard | HARRI"
            }
        ],
        route_styles: {
            framework: "bootstrap_v4"
        },
    },
    "/employees-dashboard": {
        "loginRequired": true,
        "name": "carri.dashboard",
        "type": "frontend",
        "views": {
            "body": {
                "component": "carriEmployeeDashboard",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Carri Employees Dashboard | HARRI"
            }
        ],
        route_styles: {
            framework: "bootstrap_v4"
        },
    },
    "/campaign": {
        "loginRequired": true,
        "name": "carri.campaign",
        "type": "frontend",
        "views": {
            "body": {
                "component": "carriCampaigns",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Carri Campaigns Dashboard | HARRI"
            }
        ],
        route_styles: {
            framework: "bootstrap_v4"
        },
    },
    "carri/signup": {
        "disableSSR": true,
        "loginRequired": false,
        "name": "carri_rapid_response.carri_signup",

        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./carri.module.js");
                }
            }
        ],
        "views": {
            "carri-registration-view": {
                "component": "carriSignupContainer",
            },
        },
        "onEnter": ['$modal', 'hUser', '$state', function ($modal, hUser, $state) {
            var defer = $q.defer();
            if(hUser.isEmployer()){
                $state.go('carri');
                defer.reject();
            }
            else{
                defer.resolve();
            }


            return defer.promise;
        }]
    }
};
